import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import amaxLogo from "../../images/amaxLogoWhite.png";
import API_URL from "../../api/API";

export const AthleteResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setError("Please fill all fields.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setError(null);
    setMsg(null);
    setLoading(true);

    try {
      const response = await fetch(
        `${API_URL.POST_ATHLETE_RESET_PASSWORD}${token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ password }),
        }
      );

      const json = await response.json();
      setLoading(false);

      if (response.ok) {
        setMsg(json.message);
        setPassword("");
        setConfirmPassword("");

        // Redirect to login after 2 seconds
        setTimeout(() => {
          navigate("/athlete/login");
        }, 2000);
      } else {
        setError(json.error || "Something went wrong.");
      }
    } catch (err) {
      setLoading(false);
      setError("Failed to connect to the server.");
    }
  };

  return (
    <div className="p-[20px] bg-white h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>

        <div className="w-full flex flex-col gap-8">
          <div className="flex flex-col gap-[15px]">
            <p className="text-black text-3xl xs:text-4xl leading-tight font-light">
              Reset Password <br />
              <span className="text-4xl xs:text-5xl leading-tight font-bold">
                ATHLETE.
              </span>
            </p>

            {loading && (
              <p className="text-yellow-500 text-sm mt-2">
                Resetting password, please wait...
              </p>
            )}

            {msg && (
              <p className="text-green-500 text-sm mt-2">
                {msg}
              </p>
            )}

            {error && (
              <p className="text-red-500 text-sm mt-2">
                {error}
              </p>
            )}

            <form className="flex flex-col gap-[15px]">
              <input
                type="password"
                className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                placeholder="New Password*"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <input
                type="password"
                className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                placeholder="Confirm Password*"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </form>

            <button
              onClick={handleSubmit}
              className="text-center w-full p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300"
            >
              RESET PASSWORD
            </button>

            <Link
              to="/athlete/login"
              className="w-fit text-sm xs:text-base font-light text-black hover:text-black/70 transition-all duration-300 inline-block ml-auto"
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
